import { DOC2API_URL } from 'pages/APIs';
import { getOrgId } from 'src/utils/organization/org_id_helper';
import AbstractApiService from 'src/services/abstractApiService';
import UserApiService from '../user/userApiService';
import { DeliveryCache } from 'src/constants';
export default class PurchaseOrderApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async purchase_order_dashboard(data: any): Promise<any> {
    const userService = new UserApiService();
    const receiveDeliverySetting = await userService.getCachedPreference(
      DeliveryCache.get_purchase_order_cache,
    );
    if (
      receiveDeliverySetting &&
      receiveDeliverySetting[DeliveryCache.get_purchase_order_cache] &&
      receiveDeliverySetting[DeliveryCache.get_purchase_order_cache].enabled
    ) {
      return this.getPurchaseOrderByCache(data);
    }
    return this.getPurchaseOrder(data);
  }
  public async getPurchaseOrder(data: any): Promise<any> {
    const parent_id = await this.getParentOrgId();
    data.parent_id = parent_id ? parent_id : getOrgId();
    const querystring = this.encodeQueryData(data);
    return super.get(
      DOC2API_URL +
        '/supplier_pos_invoice/get_purchase_orders' +
        '?' +
        querystring,
      {},
    );
  }
  public async getPurchaseOrderByCache(data: any): Promise<any> {
    const parent_id = await this.getParentOrgId();
    data.parent_id = parent_id ? parent_id : getOrgId();
    const querystring = this.encodeQueryData(data);
    return super.get(
      DOC2API_URL +
        '/supplier_pos_invoice/get_purchase_orders_caches' +
        '?' +
        querystring,
      {},
    );
  }
  public async purchase_order_detail(data: any): Promise<any> {
    const parent_id = await this.getParentOrgId();
    data.parent_id = parent_id ? parent_id : getOrgId();
    const querystring = this.encodeQueryData(data);
    return super.get(
      DOC2API_URL +
        '/supplier_pos_invoice/get_purchase_order_detail' +
        '?' +
        querystring,
      {},
    );
  }
  public async getPOPreviewPath(po_id: string, params: any): Promise<any> {
    const queryString = this.encodeQueryData(params);
    return super.get(
      `${DOC2API_URL}/supplier_pos_invoice/get_po_preview/${po_id}?${queryString}`,
    );
  }
}
